<div class="container-sm my-3">
    <div class="mt-5"></div>
    <div [formGroup]="formGroup" [@.disabled]="!isInsert()">
        <!-- COVERAGE NEEDS -->
        <div class="form-group row my-3">
            <label class="col-4 col-form-label">{{ "survey.new.needs-giu.coverage-needs" | translate }}</label>
            <div class="col-8">
                <div class="row border rounded mx-1">
                    <div class="col-6" *ngFor="let key of ['A', 'B', 'C', 'D', 'E', 'F']">
                        <mat-checkbox [value]="key" color="primary" (change)="onCheckChange(coverageNeeds, $event)" [disabled]="completed" [checked]="coverageNeeds?.value.includes(key)">
                            {{ "survey.domain.needs-giu.coverage-needs." + key | translate }}
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>

        <!-- BUSINESS TYPE -->
        <div class="form-group row my-3">
            <label class="col-4 col-form-label">{{ "survey.new.needs-giu.business-type" | translate }}</label>
            <div class="col-8">
                <div class="row border rounded mx-1">
                    <div class="col-6" *ngFor="let key of ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']">
                        <mat-checkbox [value]="key" color="primary" (change)="onCheckChange(businessType, $event)" [disabled]="completed" [checked]="businessType?.value.includes(key)">
                            {{ "survey.domain.needs-giu.business-type." + key | translate }}
                        </mat-checkbox>
                    </div>
                </div>
                <mat-error *ngIf="hasError(businessType)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- EMPLOYEES COVERAGE -->
        <div class="form-group row my-3" *ngIf="coverageNeeds?.value.includes('C')" [@fadeInOut]>
            <label class="col-4 col-form-label">{{ "survey.new.needs-giu.employees-coverage" | translate }}</label>
            <div class="col-8">
                <div class="row border rounded mx-1">
                    <div class="col-6" *ngFor="let key of ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'L', 'M']">
                        <mat-checkbox [value]="key" color="primary" (change)="onCheckChange(employeesCoverage, $event)" [disabled]="completed" [checked]="employeesCoverage?.value.includes(key)">
                            {{ "survey.domain.needs-giu.employees-coverage." + key | translate }}
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>

        <!-- COVERAGE PROPOSAL -->
        <div class="form-group row my-3">
            <label for="coverageProposal" class="col-4 col-form-label">{{ "survey.new.needs-giu.coverage-proposal" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="coverageProposal" formControlName="coverageProposal">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(coverageProposal)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- IS LEGAL REPRESENTATIVE -->
        <div class="form-group row my-3" *ngIf="coverageNeeds?.value.includes('A') || coverageNeeds?.value.includes('B')" [@fadeInOut]>
            <label for="legalRepresentative" class="col-4 col-form-label">{{ "survey.new.needs-giu.is-legal-representative" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="legalRepresentative" formControlName="legalRepresentative">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(legalRepresentative)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- LEGAL REPRESENTATIVE NAME -->
        <div class="form-group row my-3" *ngIf="legalRepresentative?.value == 'N'" [@fadeInOut]>
            <label for="legalRepresentativeName" class="col-4 col-form-label">{{ "survey.new.needs-giu.legal-representative-name" | translate }}</label>
            <div class="col-8">
                <input type="text" class="form-control text-capitalize" id="legalRepresentativeName" formControlName="legalRepresentativeName"/>
                <mat-error *ngIf="hasError(legalRepresentativeName)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- LEGAL REPRESENTATIVE SURNAME -->
        <div class="form-group row my-3" *ngIf="legalRepresentative?.value == 'N'" [@fadeInOut]>
            <label for="legalRepresentativeSurname" class="col-4 col-form-label">{{ "survey.new.needs-giu.legal-representative-surname" | translate }}</label>
            <div class="col-8">
                <input type="text" class="form-control text-capitalize" id="legalRepresentativeSurname" formControlName="legalRepresentativeSurname"/>
                <mat-error *ngIf="hasError(legalRepresentativeSurname)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- LEGAL REPRESENTATIVE FISCAL CODE -->
        <div class="form-group row my-3" *ngIf="legalRepresentative?.value == 'N'" [@fadeInOut]>
            <label for="legalRepresentativeFiscalCode" class="col-4 col-form-label">{{ "survey.new.needs-giu.legal-representative-fiscal-code" | translate }}</label>
            <div class="col-8">
                <input type="text" class="form-control text-uppercase" id="legalRepresentativeFiscalCode" formControlName="legalRepresentativeFiscalCode"/>
                <mat-error *ngIf="hasError(legalRepresentativeFiscalCode, 'required')">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
                <mat-error *ngIf="hasError(legalRepresentativeFiscalCode, 'pattern')">
                    {{ "data-table.validation.reg-exp" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- PREMIUM -->
        <div class="form-group row my-3" *ngIf="coverageNeeds?.value.includes('A') || coverageNeeds?.value.includes('B')" [@fadeInOut]>
            <label class="col-4 col-form-label">{{ "survey.new.needs-giu.premium" | translate }}</label>
            <div class="col-8">
                <div class="row border rounded mx-1">
                    <div class="col-6" *ngFor="let key of ['A', 'B']" >
                        <mat-checkbox [value]="key" color="primary" (change)="onCheckChange(premium, $event)" [disabled]="completed" [checked]="premium?.value.includes(key)">
                            {{ "survey.domain.needs-giu.premium." + key | translate }}
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>

        <!-- SUBMIT -->
        <button *ngIf="isInsert()" class="btn btn-primary mt-5 next-step" [disabled]="completed" (click)="onSubmit()">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            {{ "survey.new.needs-giu.next" | translate }}
        </button>
    </div>
</div>
